<template>
	<div class="gallery-wrapper" :class="[isMultiblock == 'false' ? 'container-xl' : '' ]">
		<h2 v-if="pictureData.config.title">{{ pictureData.config.title }}</h2>
		<template v-if="pictureData.config.pictures !=''">
			<div class="gallery">
				<button type="button" class="carousel-fullscreen-button" data-bs-toggle="modal" :data-bs-target="['#galleryModal-' + pictureKey]">
					<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 42 42" style="enable-background:new 0 0 42 42;" xml:space="preserve">
						<g id="Gruppe_478" transform="matrix(0.999, -0.035, 0.035, 0.999, 29.001, 2.563)">
							<path id="Pfad_445" class="st0" d="M-7.4-0.4L10,0.2L9.3,17.5"/>
						</g>
						<line id="Linie_363" class="st1" x1="39" y1="2.9" x2="3.3" y2="38.5"/>
						<g id="Gruppe_3772" transform="translate(27.991 56.591) rotate(-180)">
							<path id="Pfad_445-2" class="st2" d="M7.6,16.9L25,17.4l-0.5,17.3"/>
						</g>
					</svg>
				</button>
	
				<template v-if="pictureData.config.viewType == 'singlePicture'">
					<Splide :options="{ rewind: true, width: '100%', heightRatio: 0.5625, lazyLoad: 'nearby', arrows: 'slider'}" :class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
						<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
							<img :src="`${picture.url}`" :alt="`${picture.caption}`">
							<div class="carousel-caption d-none d-md-block">
								<span v-if="picture.caption">{{ picture.caption }}</span>
							</div>
						</SplideSlide>
					</Splide>
				</template>
				<template v-else>
					<Splide :options="{ rewind: true, width: '100%', heightRatio: 0.5625, lazyLoad: 'nearby', arrows: 'slider' }" :class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
						<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
							<img :src="`${picture.url}`" :alt="`${picture.caption}`">
							<div class="carousel-caption d-none d-md-block">
								<span v-if="picture.caption">{{ picture.caption }}</span>
							</div>
						</SplideSlide>
					</Splide>
				</template>
			</div>
	
			<!-- Modal -->
			<div class="gallery gallery-modal">
				<div class="modal" :id="['galleryModal-' + pictureKey]" tabindex="-1" :aria-labelledby="['galleryModal-' + pictureKey] + 'Label'" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-body">
								<button type="button" class="carousel-fullscreen-button" data-bs-dismiss="modal" aria-label="close">
									<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minimize"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path></svg>
								</button>
								<Splide :options="{ rewind: true, width: '100%', heightRatio: 0.5625, lazyLoad: 'nearby', arrows: 'slider'}" :class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
									<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
										<img :src="`${picture.url}`" :alt="`${picture.caption}`">
										<div class="carousel-caption d-none d-md-block">
											<span v-if="picture.caption">{{ picture.caption }}</span>
										</div>
									</SplideSlide>
								</Splide>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';

export default {
	components: {
    Splide,
    SplideSlide,
	},

	props: {
		pictureData: {
			type: Object
		},
		pictureKey: {
			type: Number
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},

	methods: {
		galleryArrows() {
			const prevButtons = document.querySelectorAll('.splide__arrow--prev');
			const nextButtons = document.querySelectorAll('.splide__arrow--next');

			for (let indexPrev = 0; indexPrev < prevButtons.length; indexPrev++) {
				const currentButton = prevButtons[indexPrev];
				
				currentButton.innerHTML = `
					<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 44 42" style="enable-background:new 0 0 44 42;" xml:space="preserve">
					<g id="Gruppe_4038" transform="translate(-233.001 -68)">
						<g id="Gruppe_478" transform="translate(273.333 108.333) rotate(180)">
							<g id="Ellipse_3" transform="translate(0.332 0.333)">
								<circle class="st0" cx="18" cy="19" r="20"/>
								<circle class="st1" cx="18" cy="19" r="19"/>
							</g>
							<path id="Pfad_445" class="st2" d="M14.3,8.9l10.4,10.4L14.3,29.7"/>
						</g>
					</g>
					</svg>
				`;
			}

			for (let indexNext = 0; indexNext < nextButtons.length; indexNext++) {
				const currentButton = nextButtons[indexNext];
				
				currentButton.innerHTML = `
					<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 44 42" style="enable-background:new 0 0 44 42;" xml:space="preserve">
					<g id="Gruppe_4038" transform="translate(-233.001 -68)">
						<g id="Gruppe_478" transform="translate(273.333 108.333) rotate(180)">
							<g id="Ellipse_3" transform="translate(0.332 0.333)">
								<circle class="st0" cx="18" cy="19" r="20"/>
								<circle class="st1" cx="18" cy="19" r="19"/>
							</g>
							<path id="Pfad_445" class="st2" d="M14.3,8.9l10.4,10.4L14.3,29.7"/>
						</g>
					</g>
					</svg>
				`;
			}
		}
	},

	mounted() {
		this.galleryArrows();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/design-aachen/galleryItemComponent.scss";
	.carousel-fullscreen-button .st0{fill:none;stroke:#fff;stroke-width:2;stroke-miterlimit:9.9961;}
	.carousel-fullscreen-button .st1{fill:none;stroke:#fff;stroke-width:2;}
	.carousel-fullscreen-button .st2{fill:none;stroke:#fff;stroke-width:2;stroke-miterlimit:10;}
</style>